import { render, staticRenderFns } from "./VietinShop.vue?vue&type=template&id=7e59b16c&scoped=true"
import script from "./VietinShop.vue?vue&type=script&lang=js"
export * from "./VietinShop.vue?vue&type=script&lang=js"
import style0 from "./VietinShop.vue?vue&type=style&index=0&id=7e59b16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e59b16c",
  null
  
)

export default component.exports